import { environment } from "./../../../environments/environment";
import { Component, OnInit, HostListener } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { MessageService } from "primeng/api";
import { AdSliderService } from "../AdSliderService/api/ad-slider.service";
import { Title } from "@angular/platform-browser";
import { SessionService } from "../../common/services/session.service";

@Component({
  selector: "app-ad-slider",
  templateUrl: "./ad-slider.component.html",
  styleUrls: ["./ad-slider.component.scss"],
})
export class AdSliderComponent implements OnInit {
  sliderArray: any;
  transform: number;
  selectedIndex = 0;
  time: number = 5000;
  interval: any;
  reset: any;
  timeInterval: any;
  beforeInterval: any;
  fullscreen: boolean = false;
  innerHeight: any = 300;
  innerWidth: any = 300;
  circle = true;
  //animation for slider
  slideLeft: boolean = false;
  slideRight: boolean = false;
  slideBottom: boolean = false;
  sildeTop: boolean = false;
  GroupId: any;
  baseUrl: string;
  //animation for slider
  instanceConfig: any;

  constructor(
    private actRoute: ActivatedRoute,
    private toast: MessageService,
    private router: Router,
    private adSlider: AdSliderService,
    //private arouter:ActivatedRoute,
    private titleService: Title,
    private ss: SessionService
  ) {
    this.instanceConfig = this.actRoute.snapshot.data.instanceConfig;
    this.processInstanceConfig();

    this.sliderArray = [
      {
        id: "1",
        type: "image",
        path: "assets/media/slider-1.jpg",
        time: 9000,
        isSizeSet: false,
      },
      {
        id: "2",
        type: "image",
        path: "assets/media/slider-2.jpg",
        time: 9000,
        isSizeSet: false,
      },
      {
        id: "3",
        type: "image",
        path: "assets/media/slider-3.jpg",
        time: 9000,
        isSizeSet: false,
      },
      {
        id: "4",
        type: "video",
        path:
          "https://firebasestorage.googleapis.com/v0/b/first-demo-project-84187.appspot.com/o/Videos%2Fvideo2.mp4?alt=media&token=f3e9c94e-4b7f-4903-ba4b-88a40098b38d",
        time: 500000,
        isTimeUpdated: false,
      },
      // { id: "5", type: "video", path: "https://firebasestorage.googleapis.com/v0/b/first-demo-project-84187.appspot.com/o/Videos%2Fvideo.mp4?alt=media&token=5e795168-8b41-450e-83fa-bba6530cf554", time: 5000, isTimeUpdated: false }
    ];

    this.selectedIndex = 0;
    this.transform = 100;
    this.slideBottom = true; //set true for animation
  }
  // currentSelected() {
  //   //add slide out animation of first slide
  //   if (this.slideBottom === true) {
  //     let element;
  //     if (this.selectedIndex < this.sliderArray.length - 1) {
  //       if (this.selectedIndex == 0) {
  //         element = document.getElementById(this.sliderArray[this.selectedIndex].id);
  //       } else {
  //         element = document.getElementById(this.sliderArray[this.selectedIndex - 1].id);
  //       }

  //       element.classList.remove('slide-bottom');
  //       element.classList.add('slide-bottom-up');
  //       clearInterval(this.beforeInterval);
  //       this.beforeInterval = setInterval(() => this.currentSelected(), this.time - 500);
  //     }
  //   }
  // }

  //for next silde setting
  downSelected() {
    // this.beforeInterval = setInterval(() => {
    //   this.currentSelected();
    // }, this.time - 500);

    this.transform = 100 * 50;

    if (this.selectedIndex < this.sliderArray.length - 1) {
      this.selectedIndex = this.selectedIndex + 1; //set index to next item

      let element = document.getElementById(
        this.sliderArray[this.selectedIndex].id
      );
      element.classList.remove("slide-bottom-up");
      element.classList.add("slide-bottom");

      if (this.sliderArray[this.selectedIndex].mediaType === "VIDEO") {
        if (!this.sliderArray[this.selectedIndex].isTimeUpdated) {
          this.changeVideoTime(this.selectedIndex);
        }

        let vid: any = document.getElementById(
          this.sliderArray[this.selectedIndex].id
        );

        setTimeout(() => {
          // Show loading animation.
          vid.currentTime = 0;
          let playPromise = vid.play();

          playPromise
            .then(
              () => {
                // Automatic playback started!
                // Show playing UI.
                this.circle = false;
              },
              (error) => {
                //vid.play();
                setTimeout(() => {
                  vid.currentTime = 0;
                  vid.play();
                });
              }
            )
            .catch((error) => {
              // Auto-play was prevented
              // Show paused UI.
            });
        });
      }

      this.time = this.sliderArray[this.selectedIndex].time;
    } else {
      this.time = this.sliderArray[0].time;
      this.selectedIndex = 0;
    }
    clearInterval(this.timeInterval);
    this.timeInterval = setInterval(() => this.downSelected(), this.time);
  }

  fullScreen(fullscreen) {
    if (fullscreen) {
      if (document["mozCancelFullScreen"]) {
        /* Firefox */
        document["mozCancelFullScreen"]();
      } else if (document["webkitExitFullscreen"]) {
        /* Chrome, Safari and Opera */
        document["webkitExitFullscreen"]();
      } else if (document["msExitFullscreen"]) {
        /* IE/Edge */
        document["msExitFullscreen"]();
      } else if (document.exitFullscreen) {
        document.exitFullscreen();
      }
      this.fullscreen = false;
    } else {
      let elem = document.documentElement;
      let methodToBeInvoked =
        elem["webkitRequestFullScreen"] ||
        elem["mozRequestFullscreen"] ||
        elem["msRequestFullscreen"] ||
        elem.requestFullscreen;
      if (methodToBeInvoked) {
        this.fullscreen = true;
        methodToBeInvoked.call(elem);
      }
    }
  }

  changeVideoTime(index) {
    let vid: any = document.getElementById(this.sliderArray[index].id);
    this.sliderArray[index].time = vid.duration * 1000;
    this.sliderArray[index].isTimeUpdated = true;
  }

  @HostListener("window:keydown.escape", ["$event"])
  onKeydownHandler(event: KeyboardEvent) {
    this.fullscreen = false;
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.innerHeight = window.innerHeight - 3;
    this.innerWidth = window.innerWidth - 3;

    this.sliderArray.forEach((image, index) => {
      if (image.isSizeSet == true && image.mediaType == "IMAGE") {
        this.sliderArray[index].isSizeSet = false;
      }
    });
    this.setImageSize();
  }

  setScreen() {
    this.innerHeight = window.innerHeight - 3;
    this.innerWidth = window.innerWidth - 3;
    (document.querySelector(
      ".img-container"
    ) as HTMLElement).style.height = this.innerHeight;
  }

  setImageSize() {
    this.sliderArray.forEach((image, index) => {
      if (image.mediaType == "IMAGE" && image.isSizeSet == false) {
        let myImg: any = document.getElementById(image.id);
        let realWidth = myImg.naturalWidth;
        let realHeight = myImg.naturalHeight;
        //set max size to image as per window propagation
        if (realWidth != 0 && realHeight != 0) {
          var ratio = Math.min(
            this.innerWidth / realWidth,
            this.innerHeight / realHeight
          );
          //set width and height as per image id
          document.getElementById(image.id).style.width =
            realWidth * ratio + "px";
          document.getElementById(image.id).style.height =
            realHeight * ratio + "px";
          this.sliderArray[index].isSizeSet = true;
        }
      }
    });
  }

  getUrlAdData(SliderId) {
    let temp = [];
    this.adSlider.getSliderData(SliderId).subscribe((data) => {
      temp = data["media"];
      temp.forEach((media, index) => {
        if (media.mediaType === "IMAGE") {
          temp[index].time = 10000;
          temp[index].isSizeSet = false;
        } else if (media.mediaType === "VIDEO") {
          temp[index].time = 10000;
          temp[index].isTimeUpdated = false;
        }
      });
      this.sliderArray = temp;
    });
  }

  ngOnInit() {
    this.baseUrl = environment.API_BASE;

    this.GroupId = this.actRoute.snapshot.paramMap.get("id");
    if (this.GroupId != null) {
      this.GroupId = parseInt(this.GroupId);
      this.getUrlAdData(this.GroupId);
    }

    this.timeInterval = setInterval(() => {
      this.downSelected();
    }, this.time);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.setScreen();
    });
  }

  ngAfterViewChecked() {
    setTimeout(() => {
      this.setImageSize();
    });
  }

  private processInstanceConfig() {
    if (this.instanceConfig) {
      this.titleService.setTitle(this.instanceConfig.BRANDING_PAGE_TITLE);
      // this.ss.setInstanceConfig(this.instanceConfig);
      environment.API_BASE = this.instanceConfig.BASE_API;
    }
  }
}
